export const Patient_API = {
    signIn: {signIn, registerSMS, registerFio}
}

//signIn
function signIn() {
    return { api: `/api/v2/patients/register`, method: 'POST' }
}

function registerFio() {
  return { api: `/api/v2/patients/register/fio`, method: 'POST' }
}

function registerSMS() {
  return { api: `/api/v2/patients/register/confirm`, method: 'POST' }
}